module.exports = __webpack_public_path__ + "img/electronic_no_zone.3e9ecd7a.svg";